import api from "api/api";

export const getDataCountryQuery = async () =>
  await api.get(`/settings/datacountry`);

export const getDataTvaRegimeQuery = async () =>
  await api.get(`/settings/datatvaregime`);

export const getDataPaymentConditionQuery = async () =>
  await api.get(`/settings/datapaymentcondition`);

export const getTTVquery = async () => await api.get(`/settings/ttv`);

export const getAllBoDocsQuery = async () => await api.get(`/settings/bo/all`);

export const postDocQuery = async (payload) =>
  await api.postFile(`/settings/bo`, payload);

export const editBoDocQuery = async (id, payload) =>
  await api.put(`/settings/bo?document_id=${id}`, payload);

export const editBoFileQuery = async (id, payload) =>
  await api.putFile(`/settings/bo/file?document_id=${id}`, payload);

export const getBoFileQuery = async (id) =>
  await api.get(`/settings/bo/file?document_id=${id}`);

export const getBoDocQuery = async (id) =>
  await api.get(`/settings/bo?document_id=${id}`);

export const deleteDocQuery = async (id) =>
  await api.delete(`/settings/bo?document_id=${id}`);

export const downloadFileQuery = async ({ file_id, userScope }) =>
  await api.getBlob(`/file/${file_id}?scope=${userScope}`);
  
